export class StoreConfig {
  storeId: string;
  isQmsEnabled: boolean;

  constructor(storeId: string, isQmsEnabled: boolean) {
    this.storeId = storeId;
    this.isQmsEnabled = isQmsEnabled;
  }
}
